import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { authUpdateAccount, authSetPassword } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { RequireAuth } from "./guards";
import { Shell, Card, H1, Field, Btn } from "./ui";

function AccountInner() {
  const { user, refresh, logout } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState(user?.name || "");
  const [password, setPassword] = useState("");

  const saveName = async (e) => { e.preventDefault(); try { await authUpdateAccount(name); await refresh(); toast.success("Profile updated"); } catch { toast.error("Could not update"); } };
  const savePw = async (e) => { e.preventDefault(); try { await authSetPassword(password); setPassword(""); toast.success("Password updated"); } catch (er) { toast.error(er?.response?.data?.detail || "Could not update"); } };

  return (
    <Shell>
      <div className="flex justify-between items-center">
        <H1>Account settings</H1>
        <div className="flex gap-3 text-sm">
          <Link to={user?.platform_role ? "/platform" : "/dashboard"} className="text-white/60 hover:text-[#00D26A]">Back</Link>
          <button onClick={async () => { await logout(); nav("/login"); }} className="text-white/60 hover:text-red-400" data-testid="account-logout">Sign out</button>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-6 mt-6">
        <Card>
          <h2 className="font-semibold mb-4">Profile</h2>
          <form onSubmit={saveName}>
            <Field label="Email" value={user?.email || ""} disabled />
            <Field label="Name" value={name} onChange={(e) => setName(e.target.value)} data-testid="account-name" />
            <Btn type="submit" data-testid="account-save-name">Save profile</Btn>
          </form>
        </Card>
        <Card>
          <h2 className="font-semibold mb-4">Password</h2>
          <form onSubmit={savePw}>
            <Field label="New password (min 8 chars)" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="account-password" required />
            <Btn type="submit" data-testid="account-save-password">Update password</Btn>
          </form>
        </Card>
      </div>
    </Shell>
  );
}

export default function Account() { return <RequireAuth><AccountInner /></RequireAuth>; }
